var map = {
	"./liceo1.png": 9206,
	"./liceo10.jpg": 8080,
	"./liceo11.jpg": 3661,
	"./liceo2.jpg": 381,
	"./liceo3.jpg": 8640,
	"./liceo4.jpg": 8803,
	"./liceo5.jpg": 4038,
	"./liceo6.jpg": 6177,
	"./liceo7.jpg": 6228,
	"./liceo8.jpg": 1383,
	"./liceo9.jpg": 9450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5228;